import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Deposites } from 'src/app/Models/deposite';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-deposite',
  templateUrl: './deposite.component.html',
  styleUrls: ['./deposite.component.css']
})
export class DepositeComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Deposites;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Deposites form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.YEAR_NAME == undefined || this.data.YEAR_NAME=="") {
      this.message.error("Please Enter Year Name" , "");
      isOk = false
    }
    if (this.data.AMOUNT == undefined || this.data.AMOUNT==0) {
      this.message.error("Please Enter Amount" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE == undefined ||this.data.PERCENTAGE==0) {
      this.message.error("Please Enter Percentage" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE_TOTAL == undefined ||this.data.PERCENTAGE_TOTAL==0) {
      this.message.error("Please Enter Total Percentage" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined ||this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No" , "");
      isOk = false
    }
if(isOk){


    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateDeposites(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Deposites information updated Successfully...", "");

	this.logtext = 'Update & Close - Deposites form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Deposites ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Deposites form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Deposites ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update deposites information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createDeposites(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Deposites information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Deposites form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Deposites ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Deposites();
	this.logtext = 'Save & New - Deposites form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Deposites ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add deposites information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Deposites form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Deposites ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}